export default __webpack_public_path__ + "images/COTOHA_VoiceDX_Basic.svg";